import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import loadable from '@loadable/component';
import Logout from '../../modules/logout';
import {
  AnalyticTools,
  FacebookPixels,
  GoogleTagManager,
} from '../../shared/analytics';
import { Routes } from './Routes';
import 'react-toastify/dist/ReactToastify.min.css';

const AuthRoutes = loadable(() => import('./AuthRoutes'));
const Error404 = loadable(() => import('../../components/Error404'));
const WorkspaceRoutes = loadable(() => import('./WorkspaceRoutes'));

const Redirection = () => <Redirect to={Routes.Login} />;

const LayoutRoutes = () => {
  useEffect(() => {
    AuthRoutes.preload();
    WorkspaceRoutes.preload();
    GoogleTagManager.init();
    FacebookPixels.init();
  }, []);

  return (
    <Router fallback={<span />}>
      <AnalyticTools />
      <Switch>
        <Route path='/' exact component={Redirection} />
        <Route path={Routes.Auth} component={AuthRoutes} />
        <Route path={Routes.Workspace} component={WorkspaceRoutes} />
        <Route path={Routes.Logout} component={Logout} />
        <Route path={Routes.Errors} component={Error404} />
      </Switch>
      <ToastContainer
        theme='colored'
        autoClose={10000}
        pauseOnFocusLoss
        draggable
        position={toast.POSITION.TOP_RIGHT}
      />
    </Router>
  );
};

export default LayoutRoutes;
